export default __webpack_public_path__ + "static/media/hht2_ep07_timeline_q02_a.f797800f.png";